import React from 'react';
import { Container } from 'react-bootstrap';

function Footer() {
  return (
    <footer className="bg-dark text-white py-4">
      <Container>
        <div className="text-center">
          <p className="mb-0">&copy; 2026 InternStacks - Urban Web Host Pvt Ltd. Project.</p>
          <small className="text-muted">Educational replica for learning purposes</small>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
